import React from 'react'
import SingleProjectDashboard from '../Components/ProjectSec/SingleProjectDashboard'

const SingleProjectPage = () => {
  return (
    <>
        <SingleProjectDashboard/>
    </>
  )
}

export default SingleProjectPage